import { Data, ModalUtils, NeoModel, NotifyUtils } from '@singularsystems/neo-core';
import { Views } from '@singularsystems/neo-react';
import { AppService, Types } from '../../../App/Services/AppService';
import RawGenericTransactionLookup from '../../../DataInterception/Transactions/Models/Lookups/RawGenericTransactionLookup';
import CorporateActionRelatedTransactionsSearchCriteria from '../Models/Queries/CorporateActionRelatedTransactionsSearchCriteria';
import { TextConstants } from '../../../Common/TextConstants';
import CorporateActionEventLookup from '../Models/Lookups/CorporateActionEventLookup';
import UpdateCorporateActionEventTransactionsPriceCommand from '../Models/Commands/UpdateCorporateActionEventTransactionsPriceCommand';
import { NotificationDuration } from '../../../App/Models/Enums/NotificationDuration';

@NeoModel
export default class CorporateActionEventTransactionsComponentVM extends Views.ViewModelBase {

    public showCashTransactions: boolean = false;
    public showSecurityTransactions: boolean = false;
    public showPriceUpdateModal: boolean = false;
    public selectedCorporateAction = new CorporateActionEventLookup();
    public corporateActionEventTransactionsSearchCriteria = new CorporateActionRelatedTransactionsSearchCriteria();
    public updateCorporateActionEventTransactionsPriceCommand = new UpdateCorporateActionEventTransactionsPriceCommand();
    public pageManager = new Data.PageManager(this.corporateActionEventTransactionsSearchCriteria, RawGenericTransactionLookup, this.corporateActionEventsApiClient.getCorporateActionEventRelatedTransactionsPagedList, {
        pageSize: 10,
        sortAscending: false,
        fetchInitial: false,
        initialTaskRunner: this.taskRunner
    });

    constructor(
        taskRunner = AppService.get(Types.Neo.TaskRunner),
        public corporateActionEventsApiClient = AppService.get(Types.ApiClients.CorporateActionEventsApiClient)) {
        super(taskRunner);
    }

    public async initialise() {
    }

    public closePriceUpdateModal() {
        this.showPriceUpdateModal = false;
    }

    public displayPriceUpdateModal() {
        this.showPriceUpdateModal = true;
    }

    public bulkUpdatePriceYesNoModal(content: any) {
        ModalUtils.showYesNo(TextConstants.Titles.ConfirmBulkPriceUpdate,
            content,
            () => {
                this.updateCorporateActionEventTransactionsPrice();
            })
    }

    public async updateCorporateActionEventTransactionsPrice() {
        this.showPriceUpdateModal = false;
        this.updateCorporateActionEventTransactionsPriceCommand.corporateActionEventId = this.selectedCorporateAction.corporateActionEventID;

        const response = await this.corporateActionEventsApiClient.updateCorporateActionEventTransactionsPrice(this.updateCorporateActionEventTransactionsPriceCommand.toJSObject());

        if (response.data.success) {
            NotifyUtils.addSuccess(TextConstants.Titles.Success, TextConstants.Notifications.CorporateActionEventTransactionsSaved, NotificationDuration.Standard);
            
            this.pageManager.refreshData();
        } else {
            NotifyUtils.add(TextConstants.Titles.Error, response.data.error, "danger" as any, NotificationDuration.Long);
        }
    }
}